export const availableSizesData = [
    {id:0, value:40, label: 'Yes, I am', color:'#4CAF50'}, 
    {id:1, value:40, label: 'Not sure', color: '#7A5EE4'}, 
    {id:2, value:10, label: 'Not, I could not find my size', color: '#F8BC16'}
]

export const yesAvailableSizesAvatar = {
        'City':
            [
                {id:0, value:18, label: 'Riyadh (Riyadh Region)', color:'#4CAF50'}, 
                {id:1, value:10, label: 'Mecca (Makkah Region)', color: '#7A5EE4'}, 
                {id:2, value:12, label: 'Jeddah (Makkah Region)', color: '#F8BC16'},
                {id:3, value:34, label: 'Medina (Madinah Region)', color:'#EE4F4C'}, 
                {id:4, value:20, label: 'Dammam (Eastern Province)', color: '#697180'}, 
                {id:5, value:12, label: 'Khobar (Eastern Province)', color: '#4CAF50'},
                {id:6, value:4, label: 'Abha (Asir Region)', color: '#FB8C00'},
                {id:7, value:23, label: 'Khamis Mushait (Asir Region)', color:'#6C7156'}, 
                {id:8, value:10, label: 'Buraydah (Al Qassim Region)', color: '#6C3B2A'}, 
                {id:9, value:12, label: 'Tabuk (Tabuk Region)', color: '#F54021'},
                {id:10, value:3, label: 'Najran (Najran Region)', color:'#343B29'}, 
                {id:11, value:20, label: 'Al Bahah (Al Bahah Region)', color: '#999950'}, 
                {id:12, value:12, label: 'Hail (Hail Region)', color: '#55067d'},
                {id:13, value:1, label: 'Arar (Northern Borders Region)', color: '#8B8C7A'},
                {id:14, value:12, label: 'Jizan (Jizan Region)', color: '#E4A010'},
                {id:15, value:20, label: 'Sakaka (Al Jawf Region)', color: '#008F39'}

            ],

        'Yearly income':
            [
                {id:0, value:5, label: '5,000 SAR - 10,000 SAR', color:'#00AA80'}, 
                {id:1, value:23, label: '10,001 SAR - 15,000 SAR', color: '#7A5EE4'}, 
                {id:2, value:12, label: '15,001 SAR - 20,000 SAR', color: '#F8BC16'},
                {id:3, value:12, label: '20,001 SAR - 25,000 SAR', color:'#EE4F4C'}, 
                {id:4, value:20, label: '25,001 SAR - 30,000 SAR', color: '#697180'}, 
                {id:5, value:16, label: '30,001 SAR - 40,000 SAR', color: '#4CAF50'},
                {id:6, value:4, label: '40,001 SAR - 50,000 SAR', color: '#FB8C00'},
                {id:7, value:23, label: '50,001 SAR - 70,000 SAR', color:'#6C7156'}, 
                {id:8, value:2, label: '70,001 SAR - 100,000 SAR', color: '#6C3B2A'}, 
                {id:9, value:12, label: '100,001 SAR and above', color: '#F54021'},
            ],

        'Main interests':
        [
            {id:0, value:15, label: 'ELECTRONICS', color:'#00AA80'}, 
            {id:1, value:35, label: 'CLOTHING', color: '#7A5EE4'}, 
            {id:2, value:4, label: 'JEWELRY', color: '#F8BC16'},
            {id:3, value:12, label: 'FOOTWEAR', color:'#EE4F4C'}, 
            {id:4, value:17, label: 'COSMETICS & BEAUTY', color: '#697180'}, 
            {id:5, value:9, label: 'SPORTS & OUTDOORS', color: '#4CAF50'},
            {id:6, value:10, label: 'HOME & FURNITURE', color: '#FB8C00'},
            {id:7, value:2, label: 'BOOKS & STATIONERY', color:'#6C7156'}, 
        ],

        'Average expenditure':
        [
            {id:0, value:5, label: '50 SAR - 200 SAR', color:'#00AA80'}, 
            {id:1, value:8, label: '201 SAR - 500 SAR', color: '#7A5EE4'}, 
            {id:2, value:16, label: '501 SAR - 1,000 SAR', color: '#F8BC16'},
            {id:3, value:26, label: '1,001 SAR - 2,500 SAR', color:'#EE4F4C'}, 
            {id:4, value:17, label: '2,501 SAR - 5,000 SAR', color: '#697180'}, 
            {id:5, value:9, label: '5,001 SAR - 10,000 SAR', color: '#4CAF50'},
            {id:6, value:4, label: '10,001 SAR and above', color: '#FB8C00'},
        ],

        'Preferred amenitis':
        [
            {id:0, value:25, label: 'SHOPS', color:'#00AA80'}, 
            {id:1, value:10, label: 'FOOD COURTS', color: '#7A5EE4'}, 
            {id:2, value:12, label: 'CINEMAS', color: '#F8BC16'},
            {id:3, value:2, label: 'ENTERTAINMENT', color:'#EE4F4C'}, 
            {id:4, value:2, label: 'RELAXATION AREAS', color: '#697180'}, 
        ],

    }

export const notSureAvailableSizesAvatars = {
        'City':
            [
                {id:0, value:12, label: 'Riyadh (Riyadh Region)', color:'#00AA80'}, 
                {id:1, value:10, label: 'Mecca (Makkah Region)', color: '#7A5EE4'}, 
                {id:2, value:23, label: 'Jeddah (Makkah Region)', color: '#F8BC16'},
                {id:3, value:25, label: 'Medina (Madinah Region)', color:'#EE4F4C'}, 
                {id:4, value:3, label: 'Dammam (Eastern Province)', color: '#697180'}, 
                {id:5, value:12, label: 'Khobar (Eastern Province)', color: '#4CAF50'},
                {id:6, value:14, label: 'Abha (Asir Region)', color: '#FB8C00'},
                {id:7, value:5, label: 'Khamis Mushait (Asir Region)', color:'#6C7156'}, 
                {id:8, value:2, label: 'Buraydah (Al Qassim Region)', color: '#6C3B2A'}, 
                {id:9, value:8, label: 'Tabuk (Tabuk Region)', color: '#F54021'},
                {id:10, value:9, label: 'Najran (Najran Region)', color:'#343B29'}, 
                {id:11, value:12, label: 'Al Bahah (Al Bahah Region)', color: '#999950'}, 
                {id:12, value:11, label: 'Hail (Hail Region)', color: '#55067d'},
                {id:13, value:16, label: 'Arar (Northern Borders Region)', color: '#8B8C7A'},
                {id:14, value:2, label: 'Jizan (Jizan Region)', color: '#E4A010'},
                {id:15, value:5, label: 'Sakaka (Al Jawf Region)', color: '#008F39'}

            ],

        'Yearly income':
            [
                {id:0, value:3, label: '5,000 SAR - 10,000 SAR', color:'#00AA80'}, 
                {id:1, value:20, label: '10,001 SAR - 15,000 SAR', color: '#7A5EE4'}, 
                {id:2, value:4, label: '15,001 SAR - 20,000 SAR', color: '#F8BC16'},
                {id:3, value:17, label: '20,001 SAR - 25,000 SAR', color:'#EE4F4C'}, 
                {id:4, value:12, label: '25,001 SAR - 30,000 SAR', color: '#697180'}, 
                {id:5, value:16, label: '30,001 SAR - 40,000 SAR', color: '#4CAF50'},
                {id:6, value:13, label: '40,001 SAR - 50,000 SAR', color: '#FB8C00'},
                {id:7, value:19, label: '50,001 SAR - 70,000 SAR', color:'#6C7156'}, 
                {id:8, value:10, label: '70,001 SAR - 100,000 SAR', color: '#6C3B2A'}, 
                {id:9, value:2, label: '100,001 SAR and above', color: '#F54021'},
            ],

        'Main interests':
        [
            {id:0, value:17, label: 'ELECTRONICS', color:'#00AA80'}, 
            {id:1, value:13, label: 'CLOTHING', color: '#7A5EE4'}, 
            {id:2, value:9, label: 'JEWELRY', color: '#F8BC16'},
            {id:3, value:17, label: 'FOOTWEAR', color:'#EE4F4C'}, 
            {id:4, value:12, label: 'COSMETICS & BEAUTY', color: '#697180'}, 
            {id:5, value:7, label: 'SPORTS & OUTDOORS', color: '#4CAF50'},
            {id:6, value:3, label: 'HOME & FURNITURE', color: '#FB8C00'},
            {id:7, value:9, label: 'BOOKS & STATIONERY', color:'#6C7156'}, 
        ],

        'Average expenditure':
        [
            {id:0, value:18, label: '50 SAR - 200 SAR', color:'#00AA80'}, 
            {id:1, value:9, label: '201 SAR - 500 SAR', color: '#7A5EE4'}, 
            {id:2, value:14, label: '501 SAR - 1,000 SAR', color: '#F8BC16'},
            {id:3, value:16, label: '1,001 SAR - 2,500 SAR', color:'#EE4F4C'}, 
            {id:4, value:12, label: '2,501 SAR - 5,000 SAR', color: '#697180'}, 
            {id:5, value:9, label: '5,001 SAR - 10,000 SAR', color: '#4CAF50'},
            {id:6, value:14, label: '10,001 SAR and above', color: '#FB8C00'},
        ],

        'Preferred amenitis':
        [
            {id:0, value:2, label: 'SHOPS', color:'#00AA80'}, 
            {id:1, value:29, label: 'FOOD COURTS', color: '#7A5EE4'}, 
            {id:2, value:14, label: 'CINEMAS', color: '#F8BC16'},
            {id:3, value:19, label: 'ENTERTAINMENT', color:'#EE4F4C'}, 
            {id:4, value:15, label: 'RELAXATION AREAS', color: '#697180'}, 
        ],

    }

export const noAvailableSizesAvatars = {
        'City':
            [
                {id:0, value:15, label: 'Riyadh (Riyadh Region)', color:'#00AA80'}, 
                {id:1, value:15, label: 'Mecca (Makkah Region)', color: '#7A5EE4'}, 
                {id:2, value:23, label: 'Jeddah (Makkah Region)', color: '#F8BC16'},
                {id:3, value:25, label: 'Medina (Madinah Region)', color:'#EE4F4C'}, 
                {id:4, value:34, label: 'Dammam (Eastern Province)', color: '#697180'}, 
                {id:5, value:12, label: 'Khobar (Eastern Province)', color: '#4CAF50'},
                {id:6, value:14, label: 'Abha (Asir Region)', color: '#FB8C00'},
                {id:7, value:5, label: 'Khamis Mushait (Asir Region)', color:'#6C7156'}, 
                {id:8, value:12, label: 'Buraydah (Al Qassim Region)', color: '#6C3B2A'}, 
                {id:9, value:18, label: 'Tabuk (Tabuk Region)', color: '#F54021'},
                {id:10, value:9, label: 'Najran (Najran Region)', color:'#343B29'}, 
                {id:11, value:12, label: 'Al Bahah (Al Bahah Region)', color: '#999950'}, 
                {id:12, value:1, label: 'Hail (Hail Region)', color: '#55067d'},
                {id:13, value:8, label: 'Arar (Northern Borders Region)', color: '#8B8C7A'},
                {id:14, value:12, label: 'Jizan (Jizan Region)', color: '#E4A010'},
                {id:15, value:15, label: 'Sakaka (Al Jawf Region)', color: '#008F39'}

            ],

        'Yearly income':
            [
                {id:0, value:13, label: '5,000 SAR - 10,000 SAR', color:'#00AA80'}, 
                {id:1, value:12, label: '10,001 SAR - 15,000 SAR', color: '#7A5EE4'}, 
                {id:2, value:4, label: '15,001 SAR - 20,000 SAR', color: '#F8BC16'},
                {id:3, value:16, label: '20,001 SAR - 25,000 SAR', color:'#EE4F4C'}, 
                {id:4, value:11, label: '25,001 SAR - 30,000 SAR', color: '#697180'}, 
                {id:5, value:12, label: '30,001 SAR - 40,000 SAR', color: '#4CAF50'},
                {id:6, value:21, label: '40,001 SAR - 50,000 SAR', color: '#FB8C00'},
                {id:7, value:19, label: '50,001 SAR - 70,000 SAR', color:'#6C7156'}, 
                {id:8, value:10, label: '70,001 SAR - 100,000 SAR', color: '#6C3B2A'}, 
                {id:9, value:21, label: '100,001 SAR and above', color: '#F54021'},
            ],

        'Main interests':
        [
            {id:0, value:12, label: 'ELECTRONICS', color:'#00AA80'}, 
            {id:1, value:19, label: 'CLOTHING', color: '#7A5EE4'}, 
            {id:2, value:4, label: 'JEWELRY', color: '#F8BC16'},
            {id:3, value:20, label: 'FOOTWEAR', color:'#EE4F4C'}, 
            {id:4, value:21, label: 'COSMETICS & BEAUTY', color: '#697180'}, 
            {id:5, value:4, label: 'SPORTS & OUTDOORS', color: '#4CAF50'},
            {id:6, value:5, label: 'HOME & FURNITURE', color: '#FB8C00'},
            {id:7, value:19, label: 'BOOKS & STATIONERY', color:'#6C7156'}, 
        ],

        'Average expenditure':
        [
            {id:0, value:19, label: '50 SAR - 200 SAR', color:'#00AA80'}, 
            {id:1, value:23, label: '201 SAR - 500 SAR', color: '#7A5EE4'}, 
            {id:2, value:15, label: '501 SAR - 1,000 SAR', color: '#F8BC16'},
            {id:3, value:3, label: '1,001 SAR - 2,500 SAR', color:'#EE4F4C'}, 
            {id:4, value:15, label: '2,501 SAR - 5,000 SAR', color: '#697180'}, 
            {id:5, value:28, label: '5,001 SAR - 10,000 SAR', color: '#4CAF50'},
            {id:6, value:13, label: '10,001 SAR and above', color: '#FB8C00'},
        ],

        'Preferred amenitis':
        [
            {id:0, value:18, label: 'SHOPS', color:'#00AA80'}, 
            {id:1, value:24, label: 'FOOD COURTS', color: '#7A5EE4'}, 
            {id:2, value:12, label: 'CINEMAS', color: '#F8BC16'},
            {id:3, value:12, label: 'ENTERTAINMENT', color:'#EE4F4C'}, 
            {id:4, value:10, label: 'RELAXATION AREAS', color: '#697180'}, 
        ],

    }